<script setup lang="ts">
import type { PropType } from 'vue'
import type { components } from '~/types/napis'

defineProps({
  isLoading: { type: Boolean, default: false },
  posts: {
    type:
      (Array as
        | PropType<components['schemas']['PostResponseSchema'][]>
        | PropType<components['schemas']['HistoryPostSchema'][]>) || null,
    default: null
  },
  isClass: { type: Boolean, default: false },
  showPinned: { type: Boolean, default: false },
  isAdmin: { type: Boolean, default: false },
  hideTags: { type: Boolean, default: false },
  hideFooter: { type: Boolean, default: false },
  pageSize: { type: Number, default: 2 }
})

const emit = defineEmits<{
  (e: 'refresh', postId: string | null | undefined): void
}>()
const { data: user, status } = useAuth()

const refresh = (postId: string | null | undefined) => {
  emit('refresh', postId)
}
</script>

<template>
  <div v-if="isLoading" class="post-list">
    <PageForumLoadingPost v-for="i in pageSize" :key="`post-loading-${i}`" />
  </div>

  <div v-else-if="!posts || posts.length === 0" class="post-list">there is nothing here...</div>

  <div v-else class="post-list">
    <PageForumPost
      v-for="post in posts"
      :key="`feed-post-${post.id_slug}`"
      :post="post"
      :is-admin="isAdmin"
      :is-class="isClass"
      :show-pin="showPinned"
      :hide-tags="hideTags"
      :hide-footer="hideFooter || post.groups?.includes('ANNOUNCEMENT')"
      :is-user-author="user?.id_slug ? user?.id_slug === post.author.id_slug : false"
      :user-id="user?.id_slug || ''"
      :is-authenticated="status === 'authenticated'"
      :is-bookmarked="post.is_bookmarked"
      :is-support="post.groups?.includes('SUPPORT')"
      @refresh="refresh"
    />
  </div>
</template>

<style scoped lang="scss">
.post-list {
  display: grid;
  gap: 15px;
}
</style>
